import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mic, ChevronRight } from "lucide-react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function EvaluacionOralLista() {
    const navigate = useNavigate();
    const [assessments, setAssessments] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/oral-assessments/mine")
            .then((r) => setAssessments(r.data || []))
            .catch(() => toast.error("Error cargando evaluaciones orales"))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="p-6 md:p-10 fade-in min-h-screen max-w-2xl mx-auto">
            <h1 className="text-2xl font-semibold mb-1 inline-flex items-center gap-2"><Mic size={22} className="text-edu-navy" /> Evaluación Oral</h1>
            <p className="text-edu-muted mb-6">Practica tus respuestas habladas y recibe comentarios escritos antes del examen real.</p>

            {loading ? (
                <p className="text-sm text-edu-muted">Cargando…</p>
            ) : assessments.length === 0 ? (
                <div className="edu-card p-8 text-center text-edu-muted">Tu profesor todavía no habilitó ninguna práctica oral.</div>
            ) : (
                <div className="space-y-2">
                    {assessments.map((a) => (
                        <button
                            key={a.id}
                            onClick={() => navigate(`/alumno/evaluacion-oral/${a.id}`)}
                            className="edu-card w-full text-left p-4 hover:bg-edu-soft transition-colors flex items-center justify-between gap-3"
                        >
                            <div>
                                <p className="font-medium text-sm">{a.titulo}</p>
                                <p className="text-xs text-edu-muted">{a.duracion_total_min} min · {a.tiempo_por_respuesta_seg}s por respuesta</p>
                            </div>
                            <ChevronRight size={16} className="text-edu-muted" />
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
